import { render, staticRenderFns } from "./AccessRights.vue?vue&type=template&id=01fa2efa&scoped=true"
import script from "./AccessRights.vue?vue&type=script&lang=js"
export * from "./AccessRights.vue?vue&type=script&lang=js"
import style0 from "./AccessRights.vue?vue&type=style&index=0&id=01fa2efa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fa2efa",
  null
  
)

export default component.exports